import { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import { Box, Grid, TextField, Typography } from '@material-ui/core';
import { i18n } from '../../../../language';
import { Dialog } from '../../../../components';

const COLORS_MAP = {
  '#FFFFFF': 'color',
  '#000000': 'color',
  '#EAE9E9': 'color',
  '#4C5F76': 'color',
  '#4A82D4': 'color',
  '#F28923': 'color',
  '#F6BF00': 'color',
  '#83C541': 'color',
  '#33C9BD': 'color',
  '#E94F66': 'color',

  '#F5F5F5': 'color',
  '#8B8B8B': 'color',
  '#D6D4D4': 'color',
  '#DBE1E9': 'color',
  '#DEE7F7': 'color',
  '#FDE9D9': 'color',
  '#FFF3CE': 'color',
  '#E7F4DD': 'color',
  '#D9F6F4': 'color',
  '#FBDFE3': 'color',

  '#DEDEDE': 'color',
  '#646464': 'color',
  '#B8B4B4': 'color',
  '#B5C1D1': 'color',
  '#BDCFEE': 'color',
  '#FAD2B3': 'color',
  '#FFE89A': 'color',
  '#D0E8B9': 'color',
  '#B1EDE8': 'color',
  '#F7BEC6': 'color',

  '#C6C6C6': 'color',
  '#494949': 'color',
  '#817C7C': 'color',
  '#8EA2BA': 'color',
  '#99B6E6': 'color',
  '#F8BA89': 'color',
  '#FFDC61': 'color',
  '#B7DC95': 'color',
  '#87E5DD': 'color',
  '#F29CA7': 'color',

  '#AFAFAF': 'color',
  '#2B2B2B': 'color',
  '#434040': 'color',
  '#394B5B': 'color',
  '#2B61AE': 'color',
  '#CE6500': 'color',
  '#C09500': 'color',
  '#659931': 'color',
  '#259C93': 'color',
  '#D00232': 'color',

  '#8B8B8C': 'color',
  '#0A0A0A': 'color',
  '#191818': 'color',
  '#25303D': 'color',
  '#1A4278': 'color',
  '#904400': 'color',
  '#866600': 'color',
  '#456A1F': 'color',
  '#176C65': 'color',
  '#910021': 'color',

  '#C90000': 'color',
  '#FF0000': 'color',
  '#FFC400': 'color',
  '#FFFD00': 'color',
  '#9FD550': 'color',
  '#11B955': 'color',
  '#00BCF5': 'color',
  '#007ECA': 'color',
  '#00266D': 'color',
  '#7939AD': 'color',
};

const sortedColorCodes = Object.keys(COLORS_MAP);

const colorLowerMap = {};

Object.keys(COLORS_MAP).forEach((key) => {
  const lkey0 = key.toLowerCase();
  const lkey1 = COLORS_MAP[key].toLowerCase();
  const vals = [key, COLORS_MAP[key]];
  colorLowerMap[lkey0] = vals;
  colorLowerMap[lkey1] = vals;
});

function getColorName(key) {
  const lkey = key.toLowerCase();
  const val = colorLowerMap[lkey];
  if (val) return val[1];
  return '';
}

const ColorSelecter = (props, ref) => {
  const [dialogTitle, dialogTitleSet] = useState('Select Background Color');
  const [subTitle, subTitleSet] = useState('');
  const [open, openSet] = useState(false);
  const [selectedValue, selectedValueSet] = useState('');

  const onConfirm = useRef();

  useImperativeHandle(ref, () => ({
    init: () => {
      selectedValueSet('');
    },

    setOnConfirm: (fn) => {
      onConfirm.current = fn;
    },
    setSelectedColor: (color) => {
      selectedValueSet(color);
    },
    open: () => {
      openSet(true);
    },
    close: () => {
      openSet(false);
    },
    setDialogTitle: (title) => {
      dialogTitleSet(title);
    },
    setSubTitle: (title) => {
      subTitleSet(title);
    },
  }));

  return (
    <Dialog
      title={dialogTitle}
      cancel={i18n.t('DUTYASSIGN_CANCEL')}
      confirm={i18n.t('DUTYASSIGN_CONFIRM')}
      open={open}
      id="DutyAssign-Dialog-agx"
      handleOnClose={() => {
        return;
      }}
      handleClose={() => {
        openSet(false);
      }}
      handleCancel={() => {
        openSet(false);
      }}
      handleConfirm={() => {
        onConfirm.current(selectedValue);
      }}
      width={460}
    >
      <Typography>{i18n.t('DUTYASSIGN_ROSTER_SELECT_BACKGROUND_COLOR')}</Typography>
      <Typography
        style={{
          marginBottom: '1em',
          marginTop: '0.5rem',
          backgroundColor: selectedValue,
          width: 30,
          height: 30,
        }}
        id="selected-color"
      />

      <fieldset style={{ borderStyle: 'dashed', backgroundColor: 'E5E4E3' }}>
        <legend>
          <Typography>{i18n.t('DUTYASSIGN_ROSTER_TEMPLATE_SELECT_COLOR')}</Typography>
        </legend>
        <Grid container spacing={0}>
          {sortedColorCodes.map((cn, cni) => (
            <Grid key={`select color  + ${COLORS_MAP[cn]}`} item xs={10} sm={1} style={{ margin: 3 }}>
              <Box
                style={{ backgroundColor: cn, cursor: 'pointer', maxWidth: '10%' }}
                p={2}
                title={COLORS_MAP[cn]}
                onClick={() => {
                  selectedValueSet(cn);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </fieldset>
    </Dialog>
  );
};

export default forwardRef(ColorSelecter);
